import { Filter, ChevronDown } from 'lucide-react';

interface FilterDropdownButtonProps {
  onClick: () => void;
  label: React.ReactNode;
}

export default function FilterDropdownButton({ onClick, label }: FilterDropdownButtonProps) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-3 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
    >
      <Filter className="w-4 h-4 text-gray-500" />
      <span className="text-gray-700">{label}</span>
      <ChevronDown className="w-4 h-4 text-gray-500" />
    </button>
  );
}
